<script>
  import {mc} from '@/core';
  import {lang$, userInfo$} from '@/store';
  import {accountApi} from '@/api';
  import {userStatus$} from '@/streams/auth';
  import {languages$} from '@/streams/languages';

  function handleClickLanguageFun(lang) {
    return function () {
      if ($userStatus$ === 'Login') {
        updateProfile({lang});
        return;
      }
      lang$.set(lang);
    };
  }

  async function updateProfile(params) {
    const {data, error} = await accountApi.updateProfile(params);
    if (data) {
      userInfo$.next(data);
      const {lang} = params;
      if (lang) {
        lang$.set(lang);
      }
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
  }
</script>

<style>
  .wrap {
    width: 100%;
  }
  section {
    background: transparent;
  }
  :global(.dark) section {
    background: #2e3546;
  }
  .active {
    color: var(--menu-light-hover) !important;
  }
  .item {
    box-sizing: border-box;
    padding: 12px;
    width: 50%;
    height: 48px;
    line-height: 24px;
    color: #fff;
  }
  .item:hover {
    border-radius: 8px;
    background: #39424F;
  }
  .wrap-ul {
    flex-wrap: wrap;
  }
</style>

<div class="wrap dib fw1 f14">
  <section class="B2">
    <ul class="wrap-ul df fww lh32 T2">
      {#each $languages$ as item (item.value)}
        <li class="item cp df aic jcsb" class:active={$lang$ === item.value} on:click={handleClickLanguageFun(item.value)}>
          {item.text}
          {#if $lang$ === item.value}
            <i class="iconfont f24">&#xe745;</i>
          {/if}
        </li>
      {/each}
    </ul>
  </section>
</div>
